import { createFeature } from '@ngrx/store';
import { AccessRoleTypes } from 'src/app/models/user.model';

import UserReducer from './reducer';

export interface UserState {
  roughagePlusAppRole: AccessRoleTypes | undefined;
}

export const userFeatureKey = 'user';

export const userFeature = createFeature({
  name: userFeatureKey,
  reducer: UserReducer,
});
